// extracted by mini-css-extract-plugin
module.exports = {"expired-message":"expired-token-warning_expired-message__x0Eb_","icon-warning":"expired-token-warning_icon-warning__9c9cq","renew-link":"expired-token-warning_renew-link__hUU8a"};